import React, { useEffect, useState } from 'react';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Dropdown from 'react-bootstrap/Dropdown';
import { Redirect } from "react-router-dom";
import { LinkContainer } from 'react-router-bootstrap';

import axios from 'axios'

import { requestConstants, securityConstants } from '../../constants';

import UpdateStatusModal from './UpdateStatusModal';
import EmailModal from './EmailModal';
import ApplicationView from './ApplicationView'

import './Styles.css';

const EDITABLE_STATES = [
  requestConstants.status.IN_PROGRESS,
  requestConstants.status.SUBMITTED,
  requestConstants.status.CHANGES_REQUESTED,
  requestConstants.status.REJECTED_PROVISIONALLY,
  requestConstants.status.APPROVED_PROVISIONALLY,
  requestConstants.status.APPROVED_LICENCE_PENDING,
];

const ApplicationDetails = (props) => {
  const userId = localStorage.getItem("user_id");
  const adminUser = localStorage.getItem("role") === securityConstants.role.ADMIN;

  const {
    match: { params: { requestId } }
  } = props;

  const [request, setRequest] = useState(null);
  const [emails, setEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);

  useEffect(() => {
    const url = `${props.SERVER_URLS.api}/request/${requestId}?id=${encodeURIComponent(userId)}`;

    axios.get(url).then(response => {
      setRequest(response.data)
    }, (error) => {
      console.log(`Request to [${url}] failed with:\n${error}`);
    });
  }, [userId, requestId, props.SERVER_URLS.api]);

  useEffect(() => {
    const url = `${props.SERVER_URLS.api}/request/${requestId}/email`;

    axios.get(url).then(response => {
      setEmails(response.data);
      setSelectedEmail(null);
    }, (error) => {
      console.log(`Request to [${url}] failed with:\n${error}`);
    });
  }, [requestId, props.SERVER_URLS.api]);

  const [updateStatusDetails, setUpdateStatusDetails] = useState(null);

  const handleAbandon = () => handleUpdateStatus({
    title: 'Abandon',
    bodyText:  'Are you sure you wish to abandon this application?',
    newStatus: requestConstants.status.ABANDONED,
    danger: true,
  });

  const handleAmend = () => handleUpdateStatus({
    title: 'Amend',
    bodyText: 'Are you sure you wish to amend this application?',
    newStatus: requestConstants.status.IN_PROGRESS,
  });

  const handleUpdateStatus = ({ title, bodyText, newStatus, danger }) => {
    setUpdateStatusDetails({
      title: title || 'Update Status',
      bodyText: bodyText || `Are you sure you wish to update the status of this application to: '${newStatus}'?`,
      requestId,
      newStatus,
      danger,
      apiUrl: props.SERVER_URLS.api,
      onUpdated: () => handleStatusUpdated(newStatus),
      onCancel: () => setUpdateStatusDetails(null),
    });
  };

  const handleStatusUpdated = (newStatus) => {
    setRequest({
      ...request,
      status: newStatus,
    });

    setUpdateStatusDetails(null);
  };

  if (!request) {
    return (<h2>Loading...</h2>);
  }

  if (request.status === requestConstants.status.IN_PROGRESS && !adminUser) {
    return (
      <Redirect
        to={{
          pathname: "/ru/bw",
          state: {
            requestID: requestId,
            request_state: request.request_state,
            page_states: request.pageStates
          },
        }}
      />
    );
  }

  return (
    <>
      <ApplicationView application={request} emails={emails} onEmailClick={(e) => setSelectedEmail(e)}/>
      <ButtonToolbar className="float-right mt-3">
        {adminUser &&
        <LinkContainer to={`/ad/dashboard`}>
          <Button variant="light">
            Dashboard
          </Button>
        </LinkContainer>
        }
        {adminUser &&
        <Dropdown>
          <Dropdown.Toggle variant="success" disabled={!request || !EDITABLE_STATES.includes(request.status) || request.status === requestConstants.status.IN_PROGRESS}>
            Update Status
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {request.status !== requestConstants.status.SUBMITTED &&
            <Dropdown.Item onClick={() => handleUpdateStatus({newStatus: requestConstants.status.SUBMITTED})}>
              Submitted
            </Dropdown.Item>
            }
            {request.status !== requestConstants.status.CHANGES_REQUESTED &&
            <Dropdown.Item onClick={() => handleUpdateStatus({newStatus: requestConstants.status.CHANGES_REQUESTED})}>
              Changes Requested
            </Dropdown.Item>
            }
            {request.status !== requestConstants.status.REJECTED_PROVISIONALLY &&
            <Dropdown.Item
              onClick={() => handleUpdateStatus({newStatus: requestConstants.status.REJECTED_PROVISIONALLY})}>
              Rejected Provisionally
            </Dropdown.Item>
            }
            {request.status !== requestConstants.status.REJECTED &&
            <Dropdown.Item onClick={() => handleUpdateStatus({newStatus: requestConstants.status.REJECTED, danger: true})}>
              Rejected
            </Dropdown.Item>
            }
            {request.status !== requestConstants.status.APPROVED_PROVISIONALLY &&
            <Dropdown.Item
              onClick={() => handleUpdateStatus({newStatus: requestConstants.status.APPROVED_PROVISIONALLY})}>
              Approved Provisionally
            </Dropdown.Item>
            }
            {request.status !== requestConstants.status.APPROVED_LICENCE_PENDING &&
            <Dropdown.Item
              onClick={() => handleUpdateStatus({newStatus: requestConstants.status.APPROVED_LICENCE_PENDING})}>
              Approved Licence Pending
            </Dropdown.Item>
            }
            {request.status !== requestConstants.status.APPROVED_LICENCE_ISSUED &&
            <Dropdown.Item
              onClick={() => handleUpdateStatus({newStatus: requestConstants.status.APPROVED_LICENCE_ISSUED})}>
              Approved Licence Issued
            </Dropdown.Item>
            }
            {request.status !== requestConstants.status.ABANDONED &&
            <Dropdown.Item
              onClick={() => handleUpdateStatus({newStatus: requestConstants.status.ABANDONED})}>
              Abandoned
            </Dropdown.Item>
            }
          </Dropdown.Menu>
        </Dropdown>
        }
        {!adminUser &&
          <LinkContainer to={`/ru/list`}>
            <Button variant="light">
              Applications Dashboard
            </Button>
          </LinkContainer>
        }
        {!adminUser && request.status === requestConstants.status.REJECTED_PROVISIONALLY &&
          <Button variant="danger" onClick={handleAbandon}>
            Abandon
          </Button>
        }
        {!adminUser && request.status === requestConstants.status.CHANGES_REQUESTED &&
          <Button variant="primary" onClick={handleAmend}>
            Amend & Resubmit
          </Button>
        }
      </ButtonToolbar>
      <EmailModal email={selectedEmail} onClose={() => setSelectedEmail(null)} />
      <UpdateStatusModal show={!!updateStatusDetails} {...updateStatusDetails} />
    </>
  );
};

export default ApplicationDetails;
